<template>
  <div>
    <v-data-table
      class="main-table preview-table"
      :headers="headers"
      :items="records"
      hide-default-footer
      disable-sort
      :options="tableOptions"
    >
      <template v-slot:item="{ item, headers }">
        <tr>
          <td
            v-for="(header, colId) in headers"
            :key="`cell-${item.rowIndx}-${colId}`"
            :class="getError(item.rowIndx, colId) && 'has-error'"
          >
            <v-tooltip
              bottom
              nudge-top="10"
              v-if="getError(item.rowIndx, colId)"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="error-highlight" v-bind="attrs" v-on="on">
                    <span>
                      {{ item[header.value] }}
                    </span>
                    <v-icon
                        class="error-icon"
                        color="red"
                        small>
                      mdi-alert-circle
                    </v-icon>
                </div>
              </template>
              <div class="pa-1">
                <span class="error-header pa-1 mr-1">{{ header.text }}</span>
                <span class="error-content">{{
                  getError(item.rowIndx, colId)
                }}</span>
              </div>
            </v-tooltip>

            <span v-else>
              {{ item[header.value] }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="d-flex justify-space-between mt-9">
      <v-btn @click="$emit('reset')" color="colorUiGrey30" depressed
        >Back</v-btn
      >
    </div>
  </div>
</template>

<script>
import hasNotifications from "@/mixins/has-notifications";

const tableOptions = {
  itemsPerPage: -1
};

export default {
  name: "MonitorAlertBulkResolveErrors",
  mixins: [hasNotifications],
  props: {
    validationErrors: Array,
    records: Array
  },
  data: () => ({
    headers: [
      { text: "Row", value: "rowIndx", width: 32, align: "center" },
      { text: "Monitor Record ID", value: "csvMonitorRecordId" },
      { text: "New Progress Status", value: "csvNewProgressStatus" },
      { text: "Note", value: "csvNote" }
    ],
    tableOptions
  }),
  methods: {
    getError(rowIndx, colIndx) {
      return this.indexedValidationErrors[`${rowIndx}-${colIndx}`];
    }
  },
  computed: {
    indexedValidationErrors() {
      if (!this.validationErrors) return {};
      return this.validationErrors.reduce((acc, crt) => {
        acc[`${crt.rowIndx}-${crt.colIndx}`] = crt.errorMessage;
        return acc;
      }, {});
    }
  }
};
</script>

<style lang="sass" scoped>
.preview-table ::v-deep table
  border-collapse: collapse
  th
    height: 24px
    padding: 3px 12px
    color: $color-ui-grey-90 !important
  td
    height: 32px
    padding: 6px 12px
    color: $color-pt-black
    /* not contain colspan which means no data */
    &:first-child:not([colspan])
      background-color: $color-ui-grey-10
    &.has-error
      padding: 0
      .error-highlight
        width: 100%
        height: 100%
        border: 1px solid $color-alert-red
        background-color: $color-alert-red-lt
        color: $color-alert-red
        display: flex
        align-items: center
        padding-left: 12px
        padding-right: 12px
        position: relative
      .error-icon
        position: absolute
        right: 5px
  th, td
    border: 1px solid $color-ui-grey-30
    white-space: nowrap
.error-header
  background-color: $color-alert-red-lt
  border-radius: 4px
  color: $color-alert-red
  font-weight: 700
.error-content
  /* the following styling doesn't work well with v-tooltip, although it is in the mockup */
  //color: $color-pt-black
  font-weight: 600
</style>
